import { render, staticRenderFns } from "./FormFileInput.vue?vue&type=template&id=3b3898d8&scoped=true&"
import script from "./FormFileInput.vue?vue&type=script&lang=ts&"
export * from "./FormFileInput.vue?vue&type=script&lang=ts&"
import style0 from "./FormFileInput.vue?vue&type=style&index=0&id=3b3898d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3898d8",
  null
  
)

export default component.exports